import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiGetCompetenceCards } from '../api/apiCommands'

export const getCompetenceCardsState = createAsyncThunk(
  'attendanceStudents/getCompetenceCardsState',
  async ({token, url}) => {
    return apiGetCompetenceCards(token, url)
  }
)

const initialState = {
  totalAttendanceStudents: 0,
  filteredItems: 0,
  items: [],
  status: null,
  error: null
}

const competenceCardsSlice = createSlice({
  name: 'attendanceStudents',

  initialState,

  reducers: {
    setNewStatus(state, action) {
      state.status = action.payload
    },

    nullifyCompetenceCardsList(state, action) {
      state.items = []
    }
  },

  extraReducers: {
    [getCompetenceCardsState.pending]: (state, action) => {
      state.status = 'loading'
    },

    [getCompetenceCardsState.fulfilled]: (state, action) => {
      const response = action.payload

      state.items = response.items
      state.status = 'success'
      state.error = null
    },

    [getCompetenceCardsState.rejected]: (state, action) => {
      state.status = 'failed'
      state.error = action.error.message
    },
  }
})

export default competenceCardsSlice.reducer
export const { setNewStatus, nullifyCompetenceCardsList } = competenceCardsSlice.actions